<form #addItemForm="ngForm" [ngClass]="{'disabled-content': loadingSpinner}">
  <div class="add-item-block">
    <div class="area-block">
			<textarea #addPunchItemTextArea class="text-area add-new-punch-item-area" matInput
                placeholder="Punch Item Description" [required]="true"
                minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" [mention]="users"
                [mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}" tabindex="1"
                appPasteFileDirective (filePaste)="uploadFile($event)"></textarea>

      <mat-icon class="cancel-item-button" (click)="hideInputItem()">close</mat-icon>
    </div>

    <div class="files-block">
      <app-punch-item-files [checkItem]="checkItem"></app-punch-item-files>
    </div>

    <div class="types-block">
      <app-punch-item-tags (tagChangedEmitter)="tagChanged($event)" [checkItem]="checkItem"
                           [tags]="tags"></app-punch-item-tags>
    </div>

    <div class="buttons-block">
      <button mat-button class="add-item-button" (click)="addItem()" [disabled]="!addItemForm.form.valid">
        <span *ngIf="!loadingSpinner">Add</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <p-fileUpload mode="basic" name="files" #filesForm [customUpload]="true"
                    (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
                    chooseLabel="">
      </p-fileUpload>
    </div>
  </div>
</form>
